import { render, staticRenderFns } from "./CertificacionPage.vue?vue&type=template&id=737d36ab"
import script from "./CertificacionPage.js?vue&type=script&lang=js&external"
export * from "./CertificacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports